import { FileText, Printer } from 'lucide-react';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react'
import entete from "../../../assets/img/entete_pool.png"
import { Image } from 'antd';
import BarreTop from '../../../components/docs/BarreTop';
import { DocumentFooter } from '../../../components/docs/DocumentFooter';
import { frenchDate } from '../../../variables/functions';
import { getCompagnieLogo } from '../../../hooks/useFilesHooks';
import { useReactToPrint } from 'react-to-print';

const PriseEnCharge = (props) => {
    const [logoPreviewUrl, setLogoPreviewUrl] = useState(null);
    const printRef = useRef(null);

    useEffect(() => {
        if (props?.sinistre?.contrat?.organisme?.typeOrganisme !== "POOL") {
            getCompagnieLogo(props?.sinistre?.contrat?.organisme?.code)
                .then(async (response) => {
                    const imageBytes = await response.arrayBuffer();
                    var blob = new Blob([imageBytes], { type: "image/png" });
                    var imageUrl = URL.createObjectURL(blob);
                    setLogoPreviewUrl(imageUrl);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, []);

    const handleGeneratePDF = async () => {
        const element = printRef.current;
        const html2pdf = (await import('html2pdf.js')).default;

        const opt = {
            margin: [0, 0, 0, 0],
            filename: `Prise_en_charge_${props?.priseEnCharge.numeroPriseEnCharge}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: {
                scale: 2,
                useCORS: true,
                logging: false
            },
            jsPDF: {
                unit: 'mm',
                format: 'a4',
                orientation: 'portrait'
            },
            pagebreak: {
                mode: ['avoid-all', 'css', 'legacy'],
                before: '.page-break'
            }
        };

        html2pdf().set(opt).from(element).toPdf().get('pdf').then(function (pdf) {
            window.open(pdf.output('bloburl'), '_blank');
        });
    };

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
        pageStyle: `
            @page {
                size: A4 portrait !important;
                margin: 0;
            }
            @media print {
                html, body {
                    width: 210mm;
                    height: 297mm;
                    margin: 0;
                    padding: 0;
                }
                body {
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                }
                
                .page-break {
                    page-break-before: always;
                    break-before: page;
                    display: block;
                    height: 0;
                }
                
                .no-break {
                    page-break-inside: avoid;
                    break-inside: avoid;
                }
                
                .page-container {
                    height: 297mm;
                    display: flex;
                    flex-direction: column;
                }
                
                .page-footer {
                    margin-top: auto;
                }
            }
        `,
        documentTitle: 'Attestation Prise en Charge'
    });

    const calculerTotaux = () => {
        return {
            totalReclame: props?.priseEnCharge?.charge?.reduce((sum, c) => sum + c.montantReclame, 0),
            totalRetenue: props?.priseEnCharge?.charge?.reduce((sum, c) => sum + c.montantRetenue, 0),
            totalExclu: props?.priseEnCharge?.charge?.reduce((sum, c) => sum + c.montantExclu, 0),
            totalNet: props?.priseEnCharge?.charge?.reduce((sum, c) => sum + (c.montantReclame - c.montantRetenue - c.montantExclu), 0)
        };
    };

    const totaux = calculerTotaux();
    const genreLabel = props?.priseEnCharge?.victime?.personne?.genre === 'MASCULIN' ? 'M.' : 'Mme.';

    const HeaderComponent = () => (
        <div style={{
            flexShrink: 0,
            marginBottom: '8px',
            marginLeft: '-20px',
            marginRight: '-20px',
            marginTop: '-20px',
            padding: '10px 20px 0 20px'
        }}>
            <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0px",
            }}>
                {props?.sinistre?.contrat?.organisme?.typeOrganisme !== "POOL" && (
                    <Image
                        src={logoPreviewUrl}
                        style={{
                            width: "100%",
                            height: "90px",
                        }}
                    />
                )}
                <Image
                    src={entete}
                    style={{
                        width: "100%",
                        height: "90px",
                    }}
                />
            </div>
            <BarreTop />
        </div>
    );

    const FooterComponent = () => (
        <div style={{
            marginTop: '0px',
            marginLeft: '-20px',
            marginRight: '-20px',
            marginBottom: '30px',
            padding: '5px 10px'
        }}>
            <DocumentFooter />
        </div>
    );

    return (
        <div style={{ padding: '20px', backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
            <div style={{ marginBottom: '20px', display: 'flex', gap: '10px' }}>
                <button
                    onClick={handleGeneratePDF}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '10px 20px',
                        backgroundColor: '#16a34a',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '500'
                    }}
                >
                    {/* <FileText size={18} /> Générer PDF */}
                    <Printer size={18} /> Imprimer
                </button>
                {/* <button
                    onClick={handlePrint}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '10px 20px',
                        backgroundColor: '#2563eb',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '500'
                    }}
                >
                    <Printer size={18} /> Imprimer
                </button> */}
            </div>

            <div ref={printRef} style={{
                backgroundColor: 'white',
                padding: '20px',
                maxWidth: '900px',
                margin: '0 auto',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                fontFamily: '"Roboto", Arial, sans-serif',
                lineHeight: '1.4',
                color: '#333'
            }}>
                {/* PAGE 1 */}
                <div className="page-container" style={{
                    minHeight: '297mm',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <HeaderComponent />

                    <div style={{ flex: '1' }}>
                        <div className="no-break">
                            <div style={{ textAlign: 'center', marginBottom: '10px', borderBottom: '2px solid #2563eb', paddingBottom: '8px' }}>
                                <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#1e40af' }}>
                                    ATTESTATION DE PRISE EN CHARGE
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '0px', fontSize: '11px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                                    <div style={{ fontWeight: 'bold', color: '#2563eb' }}>Numéro de Prise en Charge:</div>
                                    <div style={{ backgroundColor: '#f0f9ff', marginTop: '-8px', marginBottom: '15px', padding: '6px 10px', borderRadius: '4px' }}>{props?.priseEnCharge.numeroPriseEnCharge}</div>
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                                    <div style={{ fontWeight: 'bold', color: '#2563eb' }}>Date d'émission:</div>
                                    <div style={{ backgroundColor: '#f0f9ff', marginTop: '-8px', marginBottom: '15px', padding: '6px 10px', borderRadius: '4px' }}>{frenchDate(props?.priseEnCharge?.createdAt)}</div>
                                </div>
                            </div>
                        </div>

                        <div className="no-break" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '2px', fontSize: '11px' }}>
                            <div style={{ marginBottom: '8px', border: '1px solid #ddd', borderRadius: '6px', overflow: 'hidden' }}>
                                <div style={{ backgroundColor: '#2563eb', color: 'white', padding: '8px 12px', fontWeight: 'bold', fontSize: '11px' }}>
                                    INFORMATIONS DU SOUSCRIPTEUR
                                </div>
                                <div style={{ padding: '12px' }}>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', fontSize: '11px' }}>
                                        <div>
                                            <div style={{ fontWeight: 'bold', color: '#666', marginBottom: '2px' }}>Numéro Assuré:</div>
                                            <div style={{ color: '#333' }}>{props?.sinistre?.contrat?.souscripteur?.numeroAssureP || props?.sinistre?.contrat?.souscripteur?.numeroAssureM}</div>
                                        </div>
                                        <div>
                                            <div style={{ fontWeight: 'bold', color: '#666', marginBottom: '2px' }}>Nom Complet:</div>
                                            <div style={{ color: '#333' }}>{props?.sinistre?.contrat?.souscripteur.nom} {props?.sinistre?.contrat?.souscripteur.prenom || ""} </div>
                                        </div>
                                        <div>
                                            <div style={{ fontWeight: 'bold', color: '#666', marginBottom: '2px' }}>Téléphone:</div>
                                            <div style={{ color: '#333' }}>{props?.sinistre?.contrat?.souscripteur?.contact && props?.sinistre?.contrat?.souscripteur?.contact?.length ? `(${props?.sinistre?.contrat?.souscripteur?.contact[0]})` : ""}</div>
                                        </div>
                                        <div style={{ gridColumn: '1 / -1' }}>
                                            <div style={{ fontWeight: 'bold', color: '#666', marginBottom: '2px' }}>Adresse:</div>
                                            <div style={{ color: '#333' }}>{props?.sinistre?.contrat?.souscripteur?.adresse || ""}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginBottom: '2px', border: '1px solid #ddd', borderRadius: '6px', overflow: 'hidden' }}>
                                <div style={{ backgroundColor: '#2563eb', color: 'white', padding: '8px 12px', fontWeight: 'bold', fontSize: '11px' }}>
                                    INFORMATIONS DE LA POLICE
                                </div>
                                <div style={{ padding: '12px' }}>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', fontSize: '11px' }}>
                                        <div>
                                            <div style={{ fontWeight: 'bold', color: '#666', marginBottom: '2px' }}>Numéro de Police:</div>
                                            <div style={{ color: '#333' }}>{props?.sinistre?.contrat?.numeroPoliceP}</div>
                                        </div>
                                        <div>
                                            <div style={{ fontWeight: 'bold', color: '#666', marginBottom: '2px' }}>Catégorie d'Engin:</div>
                                            <div style={{ color: '#333' }}>{props?.sinistre?.engin?.categorie?.codeCategorie}</div>
                                        </div>
                                        <div>
                                            <div style={{ fontWeight: 'bold', color: '#666', marginBottom: '2px' }}>Date d'Effet:</div>
                                            <div style={{ color: '#333' }}>{new Date(props?.sinistre?.contrat?.dateEffet).toLocaleDateString('fr-FR')}</div>
                                        </div>
                                        <div>
                                            <div style={{ fontWeight: 'bold', color: '#666', marginBottom: '2px' }}>Date d'Échéance:</div>
                                            <div style={{ color: '#333' }}>{new Date(props?.sinistre?.contrat?.dateEcheance).toLocaleDateString('fr-FR')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="no-break" style={{ marginBottom: '4px', border: '1px solid #ddd', borderRadius: '6px', overflow: 'hidden' }}>
                            <div style={{ backgroundColor: '#2563eb', color: 'white', padding: '8px 12px', fontWeight: 'bold', fontSize: '11px' }}>
                                INFORMATIONS DU SINISTRE
                            </div>
                            <div style={{ padding: '12px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', fontSize: '11px' }}>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                                        <div style={{ fontWeight: 'bold', color: '#666', marginBottom: '2px' }}>Numéro du Sinistre: </div>
                                        <div style={{ color: '#333' }}>{props?.sinistre?.numSinistre || props?.sinistre?.numeroSinistreM}</div>
                                    </div>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                                        <div style={{ fontWeight: 'bold', color: '#666', marginBottom: '2px' }}>Numéro d'Immatriculation:</div>
                                        <div style={{ color: '#333' }}>{props?.sinistre?.engin?.immatriculation}</div>
                                    </div>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                                        <div style={{ fontWeight: 'bold', color: '#666', marginBottom: '2px' }}>Date de Survenance:</div>
                                        <div style={{ color: '#333' }}>{new Date(props?.sinistre.dateSinistre).toLocaleDateString('fr-FR')}</div>
                                    </div>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                                        <div style={{ fontWeight: 'bold', color: '#666', marginBottom: '2px' }}>Date de Déclaration:</div>
                                        <div style={{ color: '#333' }}>{new Date(props?.sinistre.dateDeclaration).toLocaleDateString('fr-FR')}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="no-break" style={{ marginBottom: '4px', backgroundColor: '#fef3c7', border: '1px solid #fbbf24', borderRadius: '6px', padding: '12px', fontSize: '11px', lineHeight: '1.6' }}>
                            <div style={{ marginBottom: '8px' }}>
                                <strong>Nous soussignés, {props?.sinistre?.contrat?.organisme?.raisonSociale}</strong>, sise {props?.sinistre?.contrat?.organisme?.siegeSocial}
                                <strong> Tel: {props?.sinistre?.contrat?.organisme?.telephone}</strong>, attestons que:
                            </div>
                            <div>
                                <strong>{genreLabel} {props?.priseEnCharge?.victime?.personne?.prenom || ""} {props?.priseEnCharge?.victime?.personne?.nom}</strong> est {`${props?.priseEnCharge?.victime?.personne?.genre === "MASCULIN" ? "pris" : "prise"}`} en charge par la compagnie,
                                <em> conformément aux dispositions de <u>l’article 258 du code CIMA</u>  qui stipule: « Les frais de toute nature peuvent être, soit remboursés à la victime sur présentation des pièces justificatives, soit pris en charge directement par l’assureur du véhicule ayant causé l’accident.</em>
                            </div>
                            <div>
                                <em>
                                    <strong style={{ fontWeight: '900' }}><u>Toutefois, leurs coûts ne sauraient excéder deux fois le tarif le plus élevé des hôpitaux publics du pays de l’accident</u></strong>  et en cas d’évaluation sanitaire justifiée par expertise, une fois le tarif le plus élevé des hôpitaux publics du pays d’accueil …»
                                </em>
                            </div>
                        </div>

                        <div className="no-break" style={{ marginBottom: '4px', border: '1px solid #ddd', borderRadius: '6px', overflow: 'hidden' }}>
                            <div style={{ backgroundColor: '#2563eb', color: 'white', padding: '8px 12px', fontWeight: 'bold', fontSize: '11px' }}>
                                DÉTAILS DE L'ACTE MÉDICAL
                            </div>
                            <div style={{ padding: '12px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', fontSize: '11px' }}>
                                    <div>
                                        <div style={{ fontWeight: 'bold', color: '#666', marginBottom: '2px' }}>Établissement:</div>
                                        <div style={{ color: '#333' }}>{props?.priseEnCharge?.etablissement?.nom}</div>
                                    </div>
                                    <div>
                                        <div style={{ fontWeight: 'bold', color: '#666', marginBottom: '2px' }}>Nature de l'Acte:</div>
                                        <div style={{ color: '#333' }}>{props?.priseEnCharge.natureActe} {props?.priseEnCharge?.codification ? `(${props?.priseEnCharge?.codification})` : ""} </div>
                                    </div>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                                        <div style={{ fontWeight: 'bold', color: '#666', marginBottom: '2px' }}>Montant Total:</div>
                                        <div style={{ color: '#16a34a', fontSize: '13px', fontWeight: 'bold' }}>{props?.priseEnCharge?.montant?.toLocaleString('fr-FR', { style: 'currency', currency: 'XOF' })}</div>
                                    </div>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                                        <div style={{ fontWeight: 'bold', color: '#666', marginBottom: '2px' }}>Durée de Validité:</div>
                                        <div style={{ color: '#333' }}>{props?.priseEnCharge?.dureeValidite}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="no-break" style={{ marginBottom: '4px', backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '6px', padding: '12px', fontSize: '11px' }}>
                            <div style={{ marginBottom: '12px' }}>
                                <div style={{ fontWeight: 'bold', color: '#166534', marginBottom: '6px', fontSize: '11px' }}>N.B.:</div>
                                <div style={{ color: '#333', lineHeight: '1.6' }}>
                                    <div style={{ marginBottom: '6px' }}>Vous voudrez bien nous adresser:</div>
                                    <ul style={{ marginLeft: '20px', marginTop: '6px', marginBottom: '6px' }}>
                                        <li>Votre facture (lue, approuvée, et signée par le patient et le médecin-chef) et la présente prise en charge</li>
                                        <li>Un rapport médical sous pli confidentiel à l'attention de notre médecin conseil</li>
                                    </ul>
                                </div>
                            </div>

                            <div>
                                <div style={{ fontWeight: 'bold', color: '#166534', marginBottom: '6px', fontSize: '11px' }}>Recommandations très importantes:</div>
                                <ul style={{ marginLeft: '20px', marginTop: '4px' }}>
                                    <li style={{ marginBottom: '4px' }}>Il est rappelé qu'une hospitalisation excédant la durée probable, mentionnée plus haut nécessite une entente préalable avec l'assureur.</li>
                                    <li>En cas de dépassement du montant, une autorisation doit être demandée à l'assureur.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="no-break" style={{ marginBottom: '2px', backgroundColor: '#ede9fe', border: '1px solid #d8b4fe', borderRadius: '6px', padding: '12px', fontSize: '11px', color: '#6b21a8', lineHeight: '1.6' }}>
                            <strong>Validité:</strong> La présente prise en charge est valable pour une période de <strong>{props?.priseEnCharge?.dureeValidite}</strong> à compter de sa date d'émission.
                        </div>
                    </div>

                    <FooterComponent />
                </div>

                {/* SAUT DE PAGE */}
                {/* <div className="page-break"></div> */}

                {/* PAGE 2 */}
                <div className="page-container page-last" style={{
                    minHeight: '297mm',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <HeaderComponent />

                    <div style={{ flex: '1' }}>
                        <div className="no-break" style={{ marginBottom: '4px', border: '1px solid #ddd', borderRadius: '6px', overflow: 'hidden' }}>
                            <div style={{ backgroundColor: '#2563eb', color: 'white', padding: '8px 12px', fontWeight: 'bold', fontSize: '11px' }}>
                                DÉTAIL DES CHARGES
                            </div>
                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '10px' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#f3f4f6', borderBottom: '2px solid #2563eb' }}>
                                        <th style={{ padding: '8px', textAlign: 'left', fontWeight: 'bold', color: '#1f2937' }}>Acte</th>
                                        <th style={{ padding: '8px', textAlign: 'right', fontWeight: 'bold', color: '#1f2937' }}>Montant Réclamé</th>
                                        <th style={{ padding: '8px', textAlign: 'right', fontWeight: 'bold', color: '#1f2937' }}>Retenue</th>
                                        <th style={{ padding: '8px', textAlign: 'right', fontWeight: 'bold', color: '#1f2937' }}>Exclu</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props?.priseEnCharge?.charge?.map((item, index) => (
                                        <tr key={item?.codeId} style={{ borderBottom: '1px solid #ddd', backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9fafb' }}>
                                            <td style={{ padding: '8px', color: '#333' }}>
                                                <div style={{ fontWeight: '500' }}>{item.acte}</div>
                                                <div style={{ fontSize: '9px', color: '#666' }}>{item?.codificationActe}</div>
                                            </td>
                                            <td style={{ padding: '8px', textAlign: 'right', color: '#16a34a', fontWeight: '500' }}>
                                                {item?.montantReclame?.toLocaleString('fr-FR')} F CFA
                                            </td>
                                            <td style={{ padding: '8px', textAlign: 'right', color: '#dc2626', fontWeight: '500' }}>
                                                {item?.montantRetenue?.toLocaleString('fr-FR')} F CFA
                                            </td>
                                            <td style={{ padding: '8px', textAlign: 'right', color: '#ea580c', fontWeight: '500' }}>
                                                {item?.montantExclu?.toLocaleString('fr-FR')} F CFA
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="no-break" style={{ marginBottom: '2px', backgroundColor: '#f0f9ff', border: '2px solid #2563eb', borderRadius: '6px', padding: '12px' }}>
                            <div style={{ fontWeight: 'bold', fontSize: '11px', color: '#1e40af', marginBottom: '10px' }}>RÉSUMÉ FINANCIER</div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px', fontSize: '11px' }}>
                                <div style={{ backgroundColor: 'white', padding: '8px', borderRadius: '4px', borderLeft: '4px solid #16a34a' }}>
                                    <div style={{ color: '#666', marginBottom: '3px' }}>Total Réclamé</div>
                                    <div style={{ fontWeight: 'bold', color: '#16a34a', fontSize: '13px' }}>{totaux.totalReclame.toLocaleString('fr-FR')} F CFA</div>
                                </div>
                                <div style={{ backgroundColor: 'white', padding: '8px', borderRadius: '4px', borderLeft: '4px solid #dc2626' }}>
                                    <div style={{ color: '#666', marginBottom: '3px' }}>Retenues</div>
                                    <div style={{ fontWeight: 'bold', color: '#dc2626', fontSize: '13px' }}>{totaux.totalRetenue.toLocaleString('fr-FR')} F CFA</div>
                                </div>
                                <div style={{ backgroundColor: 'white', padding: '8px', borderRadius: '4px', borderLeft: '4px solid #ea580c' }}>
                                    <div style={{ color: '#666', marginBottom: '3px' }}>Exclusions</div>
                                    <div style={{ fontWeight: 'bold', color: '#ea580c', fontSize: '13px' }}>{totaux.totalExclu.toLocaleString('fr-FR')} F CFA</div>
                                </div>
                            </div>
                        </div>
                        <div className="no-break" style={{ marginTop: '30px', display: 'flex', justifyContent: 'flex-end', fontSize: '11px' }}>
                            <div style={{ textAlign: 'left' }}>
                                <div style={{ marginBottom: '60px' }}>
                                    Fait à Lomé, le {frenchDate(props?.priseEnCharge?.createdAt)}
                                </div>
                                <div style={{ fontWeight: 'bold' }}>
                                    {props?.sinistre?.contrat?.organisme?.responsable}
                                </div>
                                <div style={{ fontWeight: 'bold', marginTop: '4px' }}>
                                    D.G.
                                </div>
                            </div>
                        </div>
                    </div>

                    <FooterComponent />
                </div>
            </div>

            <style>{`
                @media print {
                    body {
                        margin: 0;
                        padding: 0;
                        background: white;
                    }
                    div[style*="padding: 20px"] {
                        padding: 0 !important;
                        background: white !important;
                    }
                    button {
                        display: none !important;
                    }
                    .page-container {
                        height: 297mm;
                        display: flex;
                        flex-direction: column;
                    }
                    
                }
            `}</style>
        </div>
    );
}

PriseEnCharge.propTypes = {
    priseEnCharge: PropTypes.object.isRequired,
    sinistre: PropTypes.object.isRequired
}

export default PriseEnCharge;